import { render, staticRenderFns } from "./EmailTemplateForm.vue?vue&type=template&id=9d1240fe&scoped=true&"
import script from "./EmailTemplateForm.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateForm.vue?vue&type=style&index=0&id=9d1240fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1240fe",
  null
  
)

export default component.exports